import { BuyerRegistrationContainer } from 'components/shared/onboarding/BuyerRegistration/BuyerRegistrationContainer';

export const BuyerRegistration = (): JSX.Element => {
  return <BuyerRegistrationContainer />;
};
